import React from 'react';
import {
    MobileNavFooter,
    MobileNavFooterProps,
} from '../../components/MobileNavFooter';
import { useServerEnrolledStatsigExperiment } from '../../context/experiments';
import {
    MobileNavFooterExperiment,
    MobileNavFooterExperimentValues,
} from '../../types';

export const MobileNavFooterTestContainer = ({
    userId,
    isAuthenticated,
    activeNavIcon,
}: MobileNavFooterProps) => {
    const variantType = useGetMobileNavFooterExperimentType();
    return variantType === MobileNavFooterExperimentValues.control ? null : (
        <MobileNavFooter
            userId={userId}
            isAuthenticated={isAuthenticated}
            activeNavIcon={activeNavIcon}
        />
    );
};

function useGetMobileNavFooterExperimentType() {
    const MobileNavFooterExperimentVariant =
        useServerEnrolledStatsigExperiment<MobileNavFooterExperimentValues>({
            name: MobileNavFooterExperiment.name,
            paramName: MobileNavFooterExperiment.paramName,
            defaultValue: MobileNavFooterExperiment.values.control,
        }).variant;

    return MobileNavFooterExperimentVariant;
}
